<template>
   <div class="div-error">
       <img src="../assets/images/receiptLotteryLose@3x.png" alt="error">
       <div style="margin-top: 30px;">{{msg}}</div>
   </div>
</template>

<script>
    export default {
        name: "error",
        data(){
            return{
                msg:'系統異常，請稍後再試！'
            }
        }
    }
</script>

<style scoped>
    .div-error{
       text-align: center;
        margin-top: 100px;
    }
    img{
        width: 150px;
        margin: auto;
        display: flex;
    }
</style>